import React, { useRef, useState, useEffect } from "react";
import { Navbar, Button } from "flowbite-react";
import { HiArrowLeft } from "react-icons/hi2";
import vocationalLicenseImg from "../../../img/vocational-license.svg";
import { FaCamera } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
  handleLoadVocationalLicense,
  handleVocationalUpload,
  handleSaveVlExpiryInformation,
} from "./handler";
import { MdCheckCircle } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";

const VocationalLicenseComponent = (props) => {
  const vocationalLicenseRef = useRef(null);
  const cssForImageCard = {
    success: {
      imageDiv:
        "mt-2 mb-10 custom-card-success border rounded-md items-center shadow-none p-10",
    },
    standard: {
      imageDiv:
        "mt-2 mb-10 custom-card border rounded-md items-center shadow-none p-10",
    },
  };
  const selectedProfileType = JSON.parse(
    sessionStorage.getItem("selectedProfileType")
  );
  let [vocationalLicense, setVocationalLicense] = useState();
  let [vlExpiry, setVlExpiry] = useState("");
  let [vlIssueDate, setVlIssueDate] = useState("");
  let [validationOnSubmit, setValidationOnSubmit] = useState(false);
  const navigate = useNavigate();
  let [validation, setValidation] = useState({
    show: false,
    message: "",
    class: "",
  });
  let [userUploadedLicense, setUserUploadedLicense] = useState(false);
  let [licenseLoading, setLicenseLoading] = useState(false);

  useEffect(() => {
    handleLoadVocationalLicense(
      props.itemIndex,
      props.memberRequirement.requiredDocuments,
      setVocationalLicense,
      setUserUploadedLicense,
      vocationalLicenseImg,
      setVlExpiry,
      setVlIssueDate
    );
  }, []);

  return (
    <>
      <Navbar
        fluid={true}
        rounded={true}
        className="shadow mb-3"
        style={{ position: "fixed", width: "100%", top: "0" }}
      >
        <Navbar.Brand
          onClick={() => {
            props.setOpenUploadDocument({
              openDocument: false,
              documentType: "",
            });
          }}
        >
          <HiArrowLeft className="h-10 w-5 ml-2" />
        </Navbar.Brand>
      </Navbar>
      <div className="p-6  max-w-md m-auto" style={{ paddingTop: "80px" }}>
        <h5 className="text-2xl mb-2 font-bold tracking-tight text-gray-900 dark:text-white">
          Vocational License
        </h5>
        {validationOnSubmit && (
          <div className="error-msg">
            <span>
              Need to Vocational License before submitting for verification
            </span>
          </div>
        )}
        {validation.show && (
          <div className="error-msg">
            <span>{validation.message}</span>
          </div>
        )}
        {userUploadedLicense && (
          <div
            class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white"
            style={{ paddingRight: "10px" }}
          >
            <MdCheckCircle style={{ color: "#15BE44" }} />
          </div>
        )}
        <label className="font-bold tracking-tight text-gray-900">Image</label>
        <div
          className={
            userUploadedLicense
              ? cssForImageCard.success.imageDiv
              : cssForImageCard.standard.imageDiv
          }
        >
          {validation.show && (
            <div className={validation.class}>
              <span>{validation.message}</span>
            </div>
          )}
          <img src={vocationalLicense} className="w-auto m-auto" alt="Ryde" />
          <p className="text-xs text-gray-400 tracking-tight mt-2">
            <i>
              .We accept any of the following: <br />
              1. TDVL <br />
              2. Approval to Driver (ATD) letter <br />
              3. Letter of Approval (LOA) <br />
              4. In-Principle Approval (IPA) letter from LTA <br />
              .Ensure your face is visible. <br />
              .we accept a document photo or a screenshot from LTA ONE MOTORING
              website. <br />
            </i>
          </p>
          <Button
            pill={true}
            className="mt-5 m-auto w-sm pr-4"
            onClick={(e) => {
              e.preventDefault();
              vocationalLicenseRef.current.click();
            }}
          >
            {licenseLoading ? (
              <BsThreeDots className="h-5 w-10" />
            ) : (
              <FaCamera className="h-5 w-10" />
            )}
            <label // for="file-upload"
              className="relative cursor-pointer rounded-md font-medium"
            >
              <span>
                {licenseLoading
                  ? "Saving"
                  : userUploadedLicense
                  ? "Replace"
                  : "Upload"}
              </span>
            </label>
          </Button>
          <input
            id="file-upload"
            name="file-upload"
            type="file"
            ref={vocationalLicenseRef}
            style={{ display: "none", width: "0px" }}
            // onChange={(event)=>{handleFileChange(event,"vehicleLog")}}
            onChange={async (event) => {
              await handleVocationalUpload(
                event,
                setValidation,
                setLicenseLoading,
                setUserUploadedLicense,
                "vocationalLicense",
                "vocationalLicense",
                selectedProfileType.profileId,
                setVocationalLicense,
                navigate,
                props.memberRequirement,
                props.setMemberRequirement,
                props.itemIndex
              );
              setValidationOnSubmit(false);
            }}
          />
        </div>

        <div className="col-span-6">
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700"
          >
            VL Issue Date
          </label>
          <input
            type="date"
            name="name"
            id="name"
            autoComplete="name"
            value={vlIssueDate}
            onChange={(e) => {
              setVlIssueDate(e.target.value);
            }}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>
        
        <div className="col-span-6">
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700"
          >
            VL Expiry Date
          </label>
          <input
            type="date"
            name="name"
            id="name"
            autoComplete="name"
            value={vlExpiry}
            onChange={(e) => {
              setVlExpiry(e.target.value);
            }}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>

        <Button
          className="bg-primary w-full mt-5"
          pill={true}
          disabled={false}
          onClick={() => {
            if (userUploadedLicense) {
              handleSaveVlExpiryInformation(
                vlExpiry,
                vlIssueDate,
                selectedProfileType.profileId,
                props.memberRequirement,
                props.setMemberRequirement,
                props.itemIndex
              );

              props.setOpenUploadDocument({
                openDocument: false,
                documentType: "",
              });
            } else {
              setValidationOnSubmit(true);
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }
          }}
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default VocationalLicenseComponent;
